import * as Yup from "yup";

export const entermobileNumberValidation = Yup.object({
  mobileNumber: Yup.string().required("Mobile number is required").min(10, "Mobile number should be min 10 char."),
});

export const enterotpValidation = Yup.object({
  otp: Yup.string().required("OTP is required"),
});
